function start() {

    console.log('lifecycle :', 'start loading scene');
}

export {start};
